import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DatePicker from 'react-date-picker';
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import {Helmet} from "react-helmet";
import Moment from 'react-moment';
import { useReactToPrint } from 'react-to-print';
import XlsxPopulate from "xlsx-populate";
import { saveAs } from "file-saver";
import QuadratureElement from './QuadratureElement';
import QuadratureElementTotali from './QuadratureElementTotali';
import QuadratureElementRapporti from './QuadratureElementRapporti';
import QuadratureElementVuoto from './QuadratureElementVuoto';
import Spinner from '../../layout/Spinner';
import { getQuadraturaOreJob, getStateQuadraturaJob, cleanQuadrature } from '../../../actions/richiesta';
import { getFestivita } from '../../../actions/impostazione'; 
import { getFiliali } from '../../../actions/filiale';

const QuadratureOre = ({ 
    auth: { user },
    richiesta: { quadraturaOre, jobIdQuadratura }, 
    getQuadraturaOreJob, 
    getStateQuadraturaJob, 
    cleanQuadrature, 
    impostazione: { festivita }, 
    getFestivita, 
    filiale: { filiali }, 
    getFiliali 
}) => {

    const [dataInizioInput, setDataInizioInput] = useState((setHours(setMinutes(startOfMonth(new Date()), 0), 0)));
    const [dataFineInput, setDataFineInput] = useState((setHours(setMinutes(endOfMonth(new Date()), 59), 23)));

    const [quadraturaOreDataA, setQuadraturaOreDataA] = useState([]);
    const [quadraturaOreDataB, setQuadraturaOreDataB] = useState([]);
    const [quadraturaOreDataE, setQuadraturaOreDataE] = useState([]);
    const [quadraturaOreDataD, setQuadraturaOreDataD] = useState([]);
    const [quadraturaOreDataC, setQuadraturaOreDataC] = useState([]);
    const [totaleOreQuadratureA, setTotaleOreQuadratureA] = useState([]);
    const [totaleOreQuadratureB, setTotaleOreQuadratureB] = useState([]);
    const [totaleOreQuadratureE, setTotaleOreQuadratureE] = useState([]);
    const [totaleOreQuadratureD, setTotaleOreQuadratureD] = useState([]);
    const [totaleOreQuadratureC, setTotaleOreQuadratureC] = useState([]);
    const [totaleOreQuadratureOreFatturate, setTotaleOreQuadratureOreFatturate] = useState([]);
    const [totaleOreQuadratureOreZone, setTotaleOreQuadratureOreZone] = useState([]);
    const [totaleOreQuadratureOreNonFatturate, setTotaleOreQuadratureOreNonFatturate] = useState([]);
    const [totaleOreQuadratureTot, setTotaleOreQuadratureTot] = useState([]);
    const [totaleOreQuadratureOrdinarie, setTotaleOreQuadratureOrdinarie] = useState([]);
    const [totaleOreQuadratureNonLavorate, setTotaleOreQuadratureNonLavorate] = useState([]);
    const [totaleOreQuadratureEE, setTotaleOreQuadratureEE] = useState([]);
    const [totaleOreBancaOreRetribuita, setTotaleOreBancaOreRetribuita] = useState([]);
    const [totaleOreBancaOreDaFruire, setTotaleOreBancaOreDaFruire] = useState([]);
    const [totaleOreStraordinarie, setTotaleOreStraordinarie] = useState([]);
    const [totaleOreStraordinarieFestive, setTotaleOreStraordinarieFestive] = useState([]);
    const [totaleOreSupplementariFestive, setTotaleOreSupplementariFestive] = useState([]);
    const [totaleOreStraordinarieRiposoSpostato, setTotaleOreStraordinarieRiposoSpostato] = useState([]);
    const [totaleFlessibilita, setTotaleFlessibilita] = useState([]);
    const [totaleOreSomministrati, setTotaleOreSomministrati] = useState([]);
    const [totaleOreQuadratureF, setTotaleOreQuadratureF] = useState([]);
    const [totaleOreQuadratureG, setTotaleOreQuadratureG] = useState([]);
    const [totaleOreQuadratureDMenoG, setTotaleOreQuadratureDMenoG] = useState([]);
    const [totaleOreQuadratureRapportoBG, setTotaleOreQuadratureRapportoBG] = useState([]);
    const [totaleOreQuadratureRapportoFE, setTotaleOreQuadratureRapportoFE] = useState([]);
    const [totaleOreQuadratureRapportoFG, setTotaleOreQuadratureRapportoFG] = useState([]);
    const [filialiList, setFilialiList] = useState([]);
    const [filtraFiliale, setFiltraFiliale] = useState(null);
    const [contatoreNonArchiviate, setContatoreNonArchiviate] = useState(0);
    const [contatorePrestatiNonArchiviate, setContatorePrestatiNonArchiviate] = useState(0);
    const [waitingJob, setWaitingJob] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [loadingRichieste, setLoadingRichieste] = useState(false);
    const [nomeFiliale, setNomeFiliale] = useState("");

    const headers = [
        { label: 'descrizione', key: 'descrizione' },
        { label: 'gennaio', key: 'gennaio' },
        { label: 'febbraio', key: 'febbraio' },
        { label: 'marzo', key: 'marzo' },
        { label: 'aprile', key: 'aprile' },
        { label: 'maggio', key: 'maggio' },
        { label: 'giugno', key: 'giugno' },
        { label: 'luglio', key: 'luglio' },
        { label: 'agosto', key: 'agosto' },
        { label: 'settembre', key: 'settembre' },
        { label: 'ottobre', key: 'ottobre' },
        { label: 'novembre', key: 'novembre' },
        { label: 'dicembre', key: 'dicembre' },
        { label: 'totale', key: 'totale' }
    ];

    // ✅ INIT
    useEffect(() => {
        if (user && user.role == "organizzazione") {
            getFiliali();
        } else {
            if (user && user.filiale && user.filiale.nome) {
                setNomeFiliale(user.filiale.nome);
            }
        }
    }, [user]);

    useEffect(() => {
        if (user && user.role == "organizzazione") {
            if (filiali.length > 0) {
                let array = [];
                filiali.map(filiale => {
                    const index = user.vistaFiliali.findIndex(el => el._id == filiale._id);
                    if (index >= 0) {
                        array.push(filiale);
                        setFiltraFiliale(filiale._id);
                        setNomeFiliale(filiale.nome);
                    }
                });
                setFilialiList(array);
            }
        }
    }, [filiali]);

    useEffect(() => {
        cleanQuadrature();
        getFestivita();
    }, []);

    // ✅ POLLING JOB
    useEffect(() => {
        const interval = setInterval(() => {
            if (jobIdQuadratura && jobIdQuadratura.length > 0 && waitingJob) {
                getStateQuadraturaJob(jobIdQuadratura);
            } else {
                clearInterval(interval);
            }
        }, 3000);
        return () => clearInterval(interval);
    }, [jobIdQuadratura, waitingJob]);

    // ✅ USA AGGREGATI DAL BACKEND (NO CALCOLI!)
    useEffect(() => {
        if (!quadraturaOre || !quadraturaOre.gruppi) return;
        setWaitingJob(false);
        let arrayCSV = [];
// ⬅️ AGGIUNGI QUESTI LOG
    console.log("🔍 TIPO DATI gruppo A primo elemento:", quadraturaOre.gruppi.A[0]);
    console.log("🔍 gennaio.totale:", quadraturaOre.gruppi.A[0]?.gennaio?.totale);
    console.log("🔍 Type:", typeof quadraturaOre.gruppi.A[0]?.gennaio?.totale);
        console.log("📊 Carico aggregati dal backend...");

        // CONTATORI
        setContatoreNonArchiviate(quadraturaOre.contatori?.richiesteNonArchiviate || 0);
        setContatorePrestatiNonArchiviate(quadraturaOre.contatori?.richiestePrestatiNonArchiviate || 0);

        // GRUPPI
        const arrayGruppoA = quadraturaOre.gruppi.A || [];
        const arrayGruppoB = quadraturaOre.gruppi.B || [];
        const arrayGruppoC = quadraturaOre.gruppi.C || [];
        const arrayGruppoD = quadraturaOre.gruppi.D || [];
        const arrayGruppoE = quadraturaOre.gruppi.E || [];
        const arrayGruppoSomministrati = quadraturaOre.gruppi.somministrati || [];

        setQuadraturaOreDataA(arrayGruppoA);
        setQuadraturaOreDataB(arrayGruppoB);
        setQuadraturaOreDataC(arrayGruppoC);
        setQuadraturaOreDataD(arrayGruppoD);
        setQuadraturaOreDataE(arrayGruppoE);

        // TOTALI GRUPPI
        const totQuadA = quadraturaOre.totali.A;
        const totQuadB = quadraturaOre.totali.B;
        const totQuadC = quadraturaOre.totali.C;
        const totQuadD = quadraturaOre.totali.D;
        const totQuadE = quadraturaOre.totali.E;
        const totQuadSomministrati = quadraturaOre.totali.Somministrati;

        setTotaleOreQuadratureA(totQuadA);
        setTotaleOreQuadratureB(totQuadB);
        setTotaleOreQuadratureC(totQuadC);
        setTotaleOreQuadratureD(totQuadD);
        setTotaleOreQuadratureE(totQuadE);
        setTotaleOreSomministrati(totQuadSomministrati);

        // CSV GRUPPI
        arrayGruppoA.map(el => arrayCSV.push({descrizione: el.descrizione, gennaio: el.gennaio.totale, febbraio: el.febbraio.totale, marzo: el.marzo.totale, aprile: el.aprile.totale, maggio: el.maggio.totale, giugno: el.giugno.totale, luglio: el.luglio.totale, agosto: el.agosto.totale, settembre: el.settembre.totale, ottobre: el.ottobre.totale, novembre: el.novembre.totale, dicembre: el.dicembre.totale, totale: el.totale.totale}));
        arrayCSV.push({descrizione: "TOTALE ORE A", gennaio: totQuadA.gennaio, febbraio: totQuadA.febbraio, marzo: totQuadA.marzo, aprile: totQuadA.aprile, maggio: totQuadA.maggio, giugno: totQuadA.giugno, luglio: totQuadA.luglio, agosto: totQuadA.agosto, settembre: totQuadA.settembre, ottobre: totQuadA.ottobre, novembre: totQuadA.novembre, dicembre: totQuadA.dicembre, totale: totQuadA.totale});

        arrayGruppoB.map(el => arrayCSV.push({descrizione: el.descrizione, gennaio: el.gennaio.totale, febbraio: el.febbraio.totale, marzo: el.marzo.totale, aprile: el.aprile.totale, maggio: el.maggio.totale, giugno: el.giugno.totale, luglio: el.luglio.totale, agosto: el.agosto.totale, settembre: el.settembre.totale, ottobre: el.ottobre.totale, novembre: el.novembre.totale, dicembre: el.dicembre.totale, totale: el.totale.totale}));
        arrayCSV.push({descrizione: "TOTALE ORE B", gennaio: totQuadB.gennaio, febbraio: totQuadB.febbraio, marzo: totQuadB.marzo, aprile: totQuadB.aprile, maggio: totQuadB.maggio, giugno: totQuadB.giugno, luglio: totQuadB.luglio, agosto: totQuadB.agosto, settembre: totQuadB.settembre, ottobre: totQuadB.ottobre, novembre: totQuadB.novembre, dicembre: totQuadB.dicembre, totale: totQuadB.totale});

        arrayGruppoC.map(el => arrayCSV.push({descrizione: el.descrizione, gennaio: el.gennaio.totale, febbraio: el.febbraio.totale, marzo: el.marzo.totale, aprile: el.aprile.totale, maggio: el.maggio.totale, giugno: el.giugno.totale, luglio: el.luglio.totale, agosto: el.agosto.totale, settembre: el.settembre.totale, ottobre: el.ottobre.totale, novembre: el.novembre.totale, dicembre: el.dicembre.totale, totale: el.totale.totale}));
        arrayCSV.push({descrizione: "TOTALE ORE C", gennaio: totQuadC.gennaio, febbraio: totQuadC.febbraio, marzo: totQuadC.marzo, aprile: totQuadC.aprile, maggio: totQuadC.maggio, giugno: totQuadC.giugno, luglio: totQuadC.luglio, agosto: totQuadC.agosto, settembre: totQuadC.settembre, ottobre: totQuadC.ottobre, novembre: totQuadC.novembre, dicembre: totQuadC.dicembre, totale: totQuadC.totale});

        arrayGruppoD.map(el => arrayCSV.push({descrizione: el.descrizione, gennaio: el.gennaio.totale, febbraio: el.febbraio.totale, marzo: el.marzo.totale, aprile: el.aprile.totale, maggio: el.maggio.totale, giugno: el.giugno.totale, luglio: el.luglio.totale, agosto: el.agosto.totale, settembre: el.settembre.totale, ottobre: el.ottobre.totale, novembre: el.novembre.totale, dicembre: el.dicembre.totale, totale: el.totale.totale}));
        arrayCSV.push({descrizione: "TOTALE ORE D", gennaio: totQuadD.gennaio, febbraio: totQuadD.febbraio, marzo: totQuadD.marzo, aprile: totQuadD.aprile, maggio: totQuadD.maggio, giugno: totQuadD.giugno, luglio: totQuadD.luglio, agosto: totQuadD.agosto, settembre: totQuadD.settembre, ottobre: totQuadD.ottobre, novembre: totQuadD.novembre, dicembre: totQuadD.dicembre, totale: totQuadD.totale});

        arrayGruppoE.map(el => arrayCSV.push({descrizione: el.descrizione, gennaio: el.gennaio.totale, febbraio: el.febbraio.totale, marzo: el.marzo.totale, aprile: el.aprile.totale, maggio: el.maggio.totale, giugno: el.giugno.totale, luglio: el.luglio.totale, agosto: el.agosto.totale, settembre: el.settembre.totale, ottobre: el.ottobre.totale, novembre: el.novembre.totale, dicembre: el.dicembre.totale, totale: el.totale.totale}));
        arrayCSV.push({descrizione: "TOTALE ORE E", gennaio: totQuadE.gennaio, febbraio: totQuadE.febbraio, marzo: totQuadE.marzo, aprile: totQuadE.aprile, maggio: totQuadE.maggio, giugno: totQuadE.giugno, luglio: totQuadE.luglio, agosto: totQuadE.agosto, settembre: totQuadE.settembre, ottobre: totQuadE.ottobre, novembre: totQuadE.novembre, dicembre: totQuadE.dicembre, totale: totQuadE.totale});

        arrayCSV.push({descrizione: "SOMMA ORE SOMMINISTRATI", gennaio: totQuadSomministrati.gennaio, febbraio: totQuadSomministrati.febbraio, marzo: totQuadSomministrati.marzo, aprile: totQuadSomministrati.aprile, maggio: totQuadSomministrati.maggio, giugno: totQuadSomministrati.giugno, luglio: totQuadSomministrati.luglio, agosto: totQuadSomministrati.agosto, settembre: totQuadSomministrati.settembre, ottobre: totQuadSomministrati.ottobre, novembre: totQuadSomministrati.novembre, dicembre: totQuadSomministrati.dicembre, totale: totQuadSomministrati.totale});

        // TOTALI COMPOSITI
        setTotaleOreQuadratureOreFatturate(totQuadA);
        arrayCSV.push({descrizione: "TOTALE ORE FATTURATE (A)", gennaio: totQuadA.gennaio, febbraio: totQuadA.febbraio, marzo: totQuadA.marzo, aprile: totQuadA.aprile, maggio: totQuadA.maggio, giugno: totQuadA.giugno, luglio: totQuadA.luglio, agosto: totQuadA.agosto, settembre: totQuadA.settembre, ottobre: totQuadA.ottobre, novembre: totQuadA.novembre, dicembre: totQuadA.dicembre, totale: totQuadA.totale});

        setTotaleOreQuadratureOreZone(totQuadB);
        arrayCSV.push({descrizione: "TOTALE ORE ZONE", gennaio: totQuadB.gennaio, febbraio: totQuadB.febbraio, marzo: totQuadB.marzo, aprile: totQuadB.aprile, maggio: totQuadB.maggio, giugno: totQuadB.giugno, luglio: totQuadB.luglio, agosto: totQuadB.agosto, settembre: totQuadB.settembre, ottobre: totQuadB.ottobre, novembre: totQuadB.novembre, dicembre: totQuadB.dicembre, totale: totQuadB.totale});

        const totB = quadraturaOre.totali.OreNonFatturate;
        setTotaleOreQuadratureOreNonFatturate(totB);
        arrayCSV.push({descrizione: "TOTALE ORE NON FATTURATE (B)", gennaio: totB.gennaio, febbraio: totB.febbraio, marzo: totB.marzo, aprile: totB.aprile, maggio: totB.maggio, giugno: totB.giugno, luglio: totB.luglio, agosto: totB.agosto, settembre: totB.settembre, ottobre: totB.ottobre, novembre: totB.novembre, dicembre: totB.dicembre, totale: totB.totale});

        const totD = quadraturaOre.totali.Tot;
        setTotaleOreQuadratureTot(totD);
        arrayCSV.push({descrizione: "TOTALE ORE (D)", gennaio: totD.gennaio, febbraio: totD.febbraio, marzo: totD.marzo, aprile: totD.aprile, maggio: totD.maggio, giugno: totD.giugno, luglio: totD.luglio, agosto: totD.agosto, settembre: totD.settembre, ottobre: totD.ottobre, novembre: totD.novembre, dicembre: totD.dicembre, totale: totD.totale});

        // ORE SALVATE
        let totOrdinarie = quadraturaOre.oreSalvateAggregati.ordinarie;
        setTotaleOreQuadratureOrdinarie([totOrdinarie]);
        arrayCSV.push({descrizione: totOrdinarie.descrizione, gennaio: totOrdinarie.gennaio.totale, febbraio: totOrdinarie.febbraio.totale, marzo: totOrdinarie.marzo.totale, aprile: totOrdinarie.aprile.totale, maggio: totOrdinarie.maggio.totale, giugno: totOrdinarie.giugno.totale, luglio: totOrdinarie.luglio.totale, agosto: totOrdinarie.agosto.totale, settembre: totOrdinarie.settembre.totale, ottobre: totOrdinarie.ottobre.totale, novembre: totOrdinarie.novembre.totale, dicembre: totOrdinarie.dicembre.totale, totale: totOrdinarie.totale.totale});

        let totNonLavorate = quadraturaOre.oreSalvateAggregati.nonLavorate;
        setTotaleOreQuadratureNonLavorate([totNonLavorate]);
        arrayCSV.push({descrizione: totNonLavorate.descrizione, gennaio: totNonLavorate.gennaio.totale, febbraio: totNonLavorate.febbraio.totale, marzo: totNonLavorate.marzo.totale, aprile: totNonLavorate.aprile.totale, maggio: totNonLavorate.maggio.totale, giugno: totNonLavorate.giugno.totale, luglio: totNonLavorate.luglio.totale, agosto: totNonLavorate.agosto.totale, settembre: totNonLavorate.settembre.totale, ottobre: totNonLavorate.ottobre.totale, novembre: totNonLavorate.novembre.totale, dicembre: totNonLavorate.dicembre.totale, totale: totNonLavorate.totale.totale});

        let totE = quadraturaOre.oreSalvateAggregati.E;
        setTotaleOreQuadratureEE(totE);
        arrayCSV.push({descrizione: "TOTALE ORE (E)", gennaio: totE.gennaio, febbraio: totE.febbraio, marzo: totE.marzo, aprile: totE.aprile, maggio: totE.maggio, giugno: totE.giugno, luglio: totE.luglio, agosto: totE.agosto, settembre: totE.settembre, ottobre: totE.ottobre, novembre: totE.novembre, dicembre: totE.dicembre, totale: totE.totale});

        let totBancaRetrib = quadraturaOre.oreSalvateAggregati.bancaRetrib;
        setTotaleOreBancaOreRetribuita([totBancaRetrib]);
        arrayCSV.push({descrizione: totBancaRetrib.descrizione, gennaio: totBancaRetrib.gennaio.totale, febbraio: totBancaRetrib.febbraio.totale, marzo: totBancaRetrib.marzo.totale, aprile: totBancaRetrib.aprile.totale, maggio: totBancaRetrib.maggio.totale, giugno: totBancaRetrib.giugno.totale, luglio: totBancaRetrib.luglio.totale, agosto: totBancaRetrib.agosto.totale, settembre: totBancaRetrib.settembre.totale, ottobre: totBancaRetrib.ottobre.totale, novembre: totBancaRetrib.novembre.totale, dicembre: totBancaRetrib.dicembre.totale, totale: totBancaRetrib.totale.totale});

        let bancaOreDaFruire = quadraturaOre.oreSalvateAggregati.bancaDaFruire;
        setTotaleOreBancaOreDaFruire([bancaOreDaFruire]);
        arrayCSV.push({descrizione: bancaOreDaFruire.descrizione, gennaio: bancaOreDaFruire.gennaio.totale, febbraio: bancaOreDaFruire.febbraio.totale, marzo: bancaOreDaFruire.marzo.totale, aprile: bancaOreDaFruire.aprile.totale, maggio: bancaOreDaFruire.maggio.totale, giugno: bancaOreDaFruire.giugno.totale, luglio: bancaOreDaFruire.luglio.totale, agosto: bancaOreDaFruire.agosto.totale, settembre: bancaOreDaFruire.settembre.totale, ottobre: bancaOreDaFruire.ottobre.totale, novembre: bancaOreDaFruire.novembre.totale, dicembre: bancaOreDaFruire.dicembre.totale, totale: bancaOreDaFruire.totale.totale});

        let oreStraordinarie = quadraturaOre.oreSalvateAggregati.straordinarie;
        setTotaleOreStraordinarie([oreStraordinarie]);
        arrayCSV.push({descrizione: oreStraordinarie.descrizione, gennaio: oreStraordinarie.gennaio.totale, febbraio: oreStraordinarie.febbraio.totale, marzo: oreStraordinarie.marzo.totale, aprile: oreStraordinarie.aprile.totale, maggio: oreStraordinarie.maggio.totale, giugno: oreStraordinarie.giugno.totale, luglio: oreStraordinarie.luglio.totale, agosto: oreStraordinarie.agosto.totale, settembre: oreStraordinarie.settembre.totale, ottobre: oreStraordinarie.ottobre.totale, novembre: oreStraordinarie.novembre.totale, dicembre: oreStraordinarie.dicembre.totale, totale: oreStraordinarie.totale.totale});

        let oreSupplementariFestive = quadraturaOre.oreSalvateAggregati.supplementariFestive;
        setTotaleOreSupplementariFestive([oreSupplementariFestive]);
        arrayCSV.push({descrizione: oreSupplementariFestive.descrizione, gennaio: oreSupplementariFestive.gennaio.totale, febbraio: oreSupplementariFestive.febbraio.totale, marzo: oreSupplementariFestive.marzo.totale, aprile: oreSupplementariFestive.aprile.totale, maggio: oreSupplementariFestive.maggio.totale, giugno: oreSupplementariFestive.giugno.totale, luglio: oreSupplementariFestive.luglio.totale, agosto: oreSupplementariFestive.agosto.totale, settembre: oreSupplementariFestive.settembre.totale, ottobre: oreSupplementariFestive.ottobre.totale, novembre: oreSupplementariFestive.novembre.totale, dicembre: oreSupplementariFestive.dicembre.totale, totale: oreSupplementariFestive.totale.totale});

        let oreStraordinarieFestive = quadraturaOre.oreSalvateAggregati.straordinarieFestive;
        setTotaleOreStraordinarieFestive([oreStraordinarieFestive]);
        arrayCSV.push({descrizione: oreStraordinarieFestive.descrizione, gennaio: oreStraordinarieFestive.gennaio.totale, febbraio: oreStraordinarieFestive.febbraio.totale, marzo: oreStraordinarieFestive.marzo.totale, aprile: oreStraordinarieFestive.aprile.totale, maggio: oreStraordinarieFestive.maggio.totale, giugno: oreStraordinarieFestive.giugno.totale, luglio: oreStraordinarieFestive.luglio.totale, agosto: oreStraordinarieFestive.agosto.totale, settembre: oreStraordinarieFestive.settembre.totale, ottobre: oreStraordinarieFestive.ottobre.totale, novembre: oreStraordinarieFestive.novembre.totale, dicembre: oreStraordinarieFestive.dicembre.totale, totale: oreStraordinarieFestive.totale.totale});

        let oreStraordinarieRiposoSpostato = quadraturaOre.oreSalvateAggregati.straordinarieRiposoSpostato;
        setTotaleOreStraordinarieRiposoSpostato([oreStraordinarieRiposoSpostato]);
        arrayCSV.push({descrizione: oreStraordinarieRiposoSpostato.descrizione, gennaio: oreStraordinarieRiposoSpostato.gennaio.totale, febbraio: oreStraordinarieRiposoSpostato.febbraio.totale, marzo: oreStraordinarieRiposoSpostato.marzo.totale, aprile: oreStraordinarieRiposoSpostato.aprile.totale, maggio: oreStraordinarieRiposoSpostato.maggio.totale, giugno: oreStraordinarieRiposoSpostato.giugno.totale, luglio: oreStraordinarieRiposoSpostato.luglio.totale, agosto: oreStraordinarieRiposoSpostato.agosto.totale, settembre: oreStraordinarieRiposoSpostato.settembre.totale, ottobre: oreStraordinarieRiposoSpostato.ottobre.totale, novembre: oreStraordinarieRiposoSpostato.novembre.totale, dicembre: oreStraordinarieRiposoSpostato.dicembre.totale, totale: oreStraordinarieRiposoSpostato.totale.totale});

        let totF = quadraturaOre.totali.F;
        setTotaleOreQuadratureF(totF);
        arrayCSV.push({descrizione: "TOTALE (F)", gennaio: totF.gennaio, febbraio: totF.febbraio, marzo: totF.marzo, aprile: totF.aprile, maggio: totF.maggio, giugno: totF.giugno, luglio: totF.luglio, agosto: totF.agosto, settembre: totF.settembre, ottobre: totF.ottobre, novembre: totF.novembre, dicembre: totF.dicembre, totale: totF.totale});

        let totG = quadraturaOre.totali.G;
        setTotaleOreQuadratureG(totG);
        arrayCSV.push({descrizione: "TOTALE GENERALE (G)", gennaio: totG.gennaio, febbraio: totG.febbraio, marzo: totG.marzo, aprile: totG.aprile, maggio: totG.maggio, giugno: totG.giugno, luglio: totG.luglio, agosto: totG.agosto, settembre: totG.settembre, ottobre: totG.ottobre, novembre: totG.novembre, dicembre: totG.dicembre, totale: totG.totale});

        let diffDG = quadraturaOre.totali.DMenoG;
        setTotaleOreQuadratureDMenoG(diffDG);
        arrayCSV.push({descrizione: "DIFFERENZA (D-G)", gennaio: diffDG.gennaio, febbraio: diffDG.febbraio, marzo: diffDG.marzo, aprile: diffDG.aprile, maggio: diffDG.maggio, giugno: diffDG.giugno, luglio: diffDG.luglio, agosto: diffDG.agosto, settembre: diffDG.settembre, ottobre: diffDG.ottobre, novembre: diffDG.novembre, dicembre: diffDG.dicembre, totale: diffDG.totale});

        let rapportoBG = quadraturaOre.totali.rapportoBG;
        setTotaleOreQuadratureRapportoBG(rapportoBG);
        arrayCSV.push({descrizione: "RAPPORTO (B/G)", gennaio: rapportoBG.gennaio, febbraio: rapportoBG.febbraio, marzo: rapportoBG.marzo, aprile: rapportoBG.aprile, maggio: rapportoBG.maggio, giugno: rapportoBG.giugno, luglio: rapportoBG.luglio, agosto: rapportoBG.agosto, settembre: rapportoBG.settembre, ottobre: rapportoBG.ottobre, novembre: rapportoBG.novembre, dicembre: rapportoBG.dicembre, totale: rapportoBG.totale});

        let rapportoFE = quadraturaOre.totali.rapportoFE;
        setTotaleOreQuadratureRapportoFE(rapportoFE);
        arrayCSV.push({descrizione: "RAPPORTO (F/E)", gennaio: rapportoFE.gennaio, febbraio: rapportoFE.febbraio, marzo: rapportoFE.marzo, aprile: rapportoFE.aprile, maggio: rapportoFE.maggio, giugno: rapportoFE.giugno, luglio: rapportoFE.luglio, agosto: rapportoFE.agosto, settembre: rapportoFE.settembre, ottobre: rapportoFE.ottobre, novembre: rapportoFE.novembre, dicembre: rapportoFE.dicembre, totale: rapportoFE.totale});

        let rapportoFG = quadraturaOre.totali.rapportoFG;
        setTotaleOreQuadratureRapportoFG(rapportoFG);
        arrayCSV.push({descrizione: "RAPPORTO (F/G)", gennaio: rapportoFG.gennaio, febbraio: rapportoFG.febbraio, marzo: rapportoFG.marzo, aprile: rapportoFG.aprile, maggio: rapportoFG.maggio, giugno: rapportoFG.giugno, luglio: rapportoFG.luglio, agosto: rapportoFG.agosto, settembre: rapportoFG.settembre, ottobre: rapportoFG.ottobre, novembre: rapportoFG.novembre, dicembre: rapportoFG.dicembre, totale: rapportoFG.totale});

        let oreFlessibilita = quadraturaOre.oreSalvateAggregati.flessibilita;
        setTotaleFlessibilita([oreFlessibilita]);

        const nuovoArrayCSV = rimuoviTOTALEOREB(arrayCSV);
        setCsvData(nuovoArrayCSV);
        setLoadingRichieste(false);

        console.log("✅ Quadratura caricata dal backend!");
    }, [quadraturaOre]);

    function tuttiValoriAZero(obj) {
        return Object.values(obj).every(valore => valore === 0);
    }

    function rimuoviTOTALEOREB(arrayCSV) {
        return arrayCSV.filter(item => {
            if (item.descrizione === "TOTALE ORE B") {
                const mesi = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre", "totale"];
                const tuttiZero = mesi.every(mese => item[mese] === 0);
                return !tuttiZero;
            }
            return true;
        });
    }

    const fromMinutiToOreString = (minuti) => {
        const ore = Math.floor(minuti / 60);
        const min = Math.round(minuti % 60);
        return `${ore}:${String(min).padStart(2, '0')}`;
    };

    const onClickGeneraQuadratureOre = () => {
        setContatoreNonArchiviate(0);
        setContatorePrestatiNonArchiviate(0);
        getQuadraturaOreJob({ dataInizio: dataInizioInput, dataFine: dataFineInput, idFiliale: filtraFiliale });
        setLoadingRichieste(true);
        setWaitingJob(true);
    };

    const onChangeRangeDateInizio = (data) => {
        setDataInizioInput(data);
        setDataFineInput(setHours(setMinutes(endOfMonth(data), 59), 23));
    };

    const onChangeRangeDateFine = (data) => {
        setDataFineInput(data);
    };

    const onChangeFiltraDipendentiPerFiliale = i => {
        setFiltraFiliale(filialiList[i]._id);
        setNomeFiliale(filialiList[i].nome);
    };

    const componentRef = useRef();
    const print = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "quadratura_ore"
    });

    function getSheetData(data, header) {
        var fields = Object.keys(data[0]);
        var sheetData = data.map(function (row) {
            return fields.map(function (fieldName) {
                return row[fieldName] ? row[fieldName] : "";
            });
        });
        const headerLabel = header.map(function (row) { return row.label });
        sheetData.unshift(headerLabel);
        return sheetData;
    }

    const trasformaTabellaExcelDaMinutiAOre = (array) => {
        array.map(el => {
            if (el.descrizione !== "RAPPORTO (B/G)" && el.descrizione !== "RAPPORTO (F/E)" && el.descrizione !== "RAPPORTO (F/G)") {
                el.gennaio = el.gennaio > 0 ? fromMinutiToOreString(el.gennaio) : el.gennaio;
                el.febbraio = el.febbraio > 0 ? fromMinutiToOreString(el.febbraio) : el.febbraio;
                el.marzo = el.marzo > 0 ? fromMinutiToOreString(el.marzo) : el.marzo;
                el.aprile = el.aprile > 0 ? fromMinutiToOreString(el.aprile) : el.aprile;
                el.maggio = el.maggio > 0 ? fromMinutiToOreString(el.maggio) : el.maggio;
                el.giugno = el.giugno > 0 ? fromMinutiToOreString(el.giugno) : el.giugno;
                el.luglio = el.luglio > 0 ? fromMinutiToOreString(el.luglio) : el.luglio;
                el.agosto = el.agosto > 0 ? fromMinutiToOreString(el.agosto) : el.agosto;
                el.settembre = el.settembre > 0 ? fromMinutiToOreString(el.settembre) : el.settembre;
                el.ottobre = el.ottobre > 0 ? fromMinutiToOreString(el.ottobre) : el.ottobre;
                el.novembre = el.novembre > 0 ? fromMinutiToOreString(el.novembre) : el.novembre;
                el.dicembre = el.dicembre > 0 ? fromMinutiToOreString(el.dicembre) : el.dicembre;
                el.totale = el.totale > 0 ? fromMinutiToOreString(el.totale) : el.totale;
            }
        });
        return array;
    };

    async function saveAsExcel(data, header) {
        let newData = trasformaTabellaExcelDaMinutiAOre(data);
        XlsxPopulate.fromBlankAsync().then(async (workbook) => {
            const sheet1 = workbook.sheet(0);
            const sheetData = getSheetData(newData, header);
            const totalColumns = sheetData[0].length;

            sheet1.cell("A1").value(sheetData);
            const range = sheet1.usedRange();
            const endColumn = String.fromCharCode(64 + totalColumns);
            sheet1.row(1).style("bold", true);
            sheet1.range("A1:" + endColumn + "1").style("fill", "BFBFBF");
            range.style("border", true);
            return workbook.outputAsync().then((res) => {
                saveAs(res, "quadratura_ore.xlsx");
            });
        });
    }

    return (
        <div className="body wf-section">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{`Quadratura ore - Gestionale Vigili dell'ordine`}</title>
            </Helmet>
            <style type="text/css">
                {"@media print{@page {size: landscape; margin: 0.5cm}}"}
            </style>
            <div className="div_wrap">
                <div className="div_wrap_100">
                    <div className="div_wrap_inner_100">
                        <div className="div_container">
                            <div className="title_window">
                                <div className="title_window_p">Quadrature ore</div>
                                <span className={`${contatoreNonArchiviate === 0 ? "green_label" : "red_label"} label_incarichi`}>{`non confermati: ${contatoreNonArchiviate}`}</span>
                                <span className={`${contatorePrestatiNonArchiviate === 0 ? "green_label" : "red_label"} label_incarichi`}>{`prestati non confermate: ${contatorePrestatiNonArchiviate}`}</span>
                            </div>
                            <div className="dati_container">
                                <div className="fun_quadrature_ore">
                                    <div className="row row_datapicker">
                                        <div className="item_1 filtro_wrap_incarichi">
                                            <div id="w-node-_284812ee-7924-9f38-86bb-8d2cc43dff3c-867f153d" className="div_item_1">
                                                <div id="w-node-_80bb2acb-3043-3649-0498-379a652f3b04-867f153d" className="label_text">Data inizio</div>
                                                <div data-hover="false" data-delay="0" className="select w-dropdown">
                                                    <DatePicker
                                                        value={dataInizioInput}
                                                        format="dd/MM/y"
                                                        weekPicker
                                                        onChange={onChangeRangeDateInizio}
                                                        locale="it-IT"
                                                        clearIcon={null}
                                                        weekStartDayIndex={1}
                                                    />
                                                </div>
                                            </div>
                                            <div id="w-node-_284812ee-7924-9f38-86bb-8d2cc43dff3c-867f153d" className="div_item_1">
                                                <div id="w-node-_80bb2acb-3043-3649-0498-379a652f3b04-867f153d" className="label_text">Data fine</div>
                                                <div data-hover="false" data-delay="0" className="select w-dropdown">
                                                    <DatePicker
                                                        value={dataFineInput}
                                                        format="dd/MM/y"
                                                        weekPicker
                                                        onChange={onChangeRangeDateFine}
                                                        locale="it-IT"
                                                        clearIcon={null}
                                                        weekStartDayIndex={1}
                                                    />
                                                </div>
                                            </div>
                                            <div id="w-node-_714e71a9-0550-fe0e-26e9-8b45ac42ab89-867f153d" className="div_item_1">
                                                <div className="w-form">
                                                    <form id="email-form" name="email-form" data-name="Email Form" method="get">
                                                        <label className="w-checkbox checkbox-field"><span className="label_text w-form-label" htmlFor="checkbox-2"></span></label>
                                                        <a id="w-node-_714e71a9-0550-fe0e-26e9-8b45ac42ab90-867f153d" onClick={() => { onClickGeneraQuadratureOre() }} className="button w-button">Genera quadratura</a>
                                                    </form>
                                                </div>
                                            </div>
                                            {user && user.role == 'organizzazione' ?
                                                <div id="w-node-_284812ee-7924-9f38-86bb-8d2cc43dff3c-867f153d" className="div_item_1">
                                                    <div id="w-node-_7b40e076-1929-a489-3ae4-e7e497d010fa-867f153d" className="label_text">Filiale</div>
                                                    <div data-hover="false" data-delay="0" className="select w-dropdown">
                                                        <select className="form-control select" name="idCliente" onChange={e => onChangeFiltraDipendentiPerFiliale(e.target.value)} required>
                                                            {filialiList.map((elementoFiliale, i) => (
                                                                <option key={i} value={i} selected={elementoFiliale._id == filtraFiliale}>{elementoFiliale.nome}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                    <div ref={componentRef} className='print-landscape' id="page_quadratura">
                                        <div className="row">
                                            <h4>QUADRATURA ORE periodo <Moment format='DD/MM/YYYY'>{dataInizioInput}</Moment> - <Moment format='DD/MM/YYYY'>{dataFineInput}</Moment></h4>
                                            <h4>Filiale: {nomeFiliale}</h4>
                                        </div>
                                        <div ref={componentRef} className="row">
                                            <div className="item_2">
                                                <div className="intestazione_table">
                                                    <div className="w-layout-grid div_column_quadrature_ore intestazione">
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Descrizione</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura"></div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Gennaio</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Febbraio</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Marzo</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Aprile</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Maggio</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Giugno</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Luglio</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Agosto</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Settembre</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Ottobre</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Novembre</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Dicembre</div>
                                                        </div>
                                                        <div className="div_item_column">
                                                            <div className="item_table_quadratura">Totale</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {loadingRichieste ? <Spinner /> :
                                                <div className="body_table quadrature">
                                                    <QuadratureElement quadraturaOreData={quadraturaOreDataA} bold={false} />
                                                    <QuadratureElementTotali labelA={'TOTALE ORE A'} totaleOreQuadrature={totaleOreQuadratureA} />
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElement quadraturaOreData={quadraturaOreDataB} bold={false} />
                                                    {tuttiValoriAZero(totaleOreQuadratureB) ? '' :
                                                        <QuadratureElementTotali labelA={'TOTALE ORE B'} totaleOreQuadrature={totaleOreQuadratureB} />
                                                    }
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElement quadraturaOreData={quadraturaOreDataC} bold={false} />
                                                    <QuadratureElementTotali labelA={'TOTALE ORE C'} totaleOreQuadrature={totaleOreQuadratureC} />
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElement quadraturaOreData={quadraturaOreDataD} bold={false} />
                                                    <QuadratureElementTotali labelA={'TOTALE ORE D'} totaleOreQuadrature={totaleOreQuadratureD} />
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElement quadraturaOreData={quadraturaOreDataE} bold={false} />
                                                    <QuadratureElementTotali labelA={'TOTALE ORE E'} totaleOreQuadrature={totaleOreQuadratureE} />
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElementTotali labelA={'TOTALE ORE FATTURATE'} labelB={'(A)'} totaleOreQuadrature={totaleOreQuadratureOreFatturate} />
                                                    <QuadratureElementTotali labelA={'TOTALE ORE ZONE'} totaleOreQuadrature={totaleOreQuadratureOreZone} />
                                                    <QuadratureElementTotali labelA={'TOTALE ORE NON FATTURATE'} labelB={'(B)'} totaleOreQuadrature={totaleOreQuadratureOreNonFatturate} />
                                                    <QuadratureElementTotali labelA={'TOTALE ORE'} labelB={'(D)'} totaleOreQuadrature={totaleOreQuadratureTot} />
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElement quadraturaOreData={totaleOreQuadratureOrdinarie} bold={false} />
                                                    <QuadratureElement quadraturaOreData={totaleOreQuadratureNonLavorate} bold={false} />
                                                    <QuadratureElementTotali labelA={'TOTALE'} labelB={'(E)'} totaleOreQuadrature={totaleOreQuadratureEE} />
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElement quadraturaOreData={totaleOreBancaOreRetribuita} bold={false} />
                                                    <QuadratureElement quadraturaOreData={totaleOreBancaOreDaFruire} bold={false} />
                                                    <QuadratureElement quadraturaOreData={totaleOreStraordinarie} bold={false} />
                                                    <QuadratureElement quadraturaOreData={totaleOreSupplementariFestive} bold={false} />
                                                    <QuadratureElement quadraturaOreData={totaleOreStraordinarieFestive} bold={false} />
                                                    <QuadratureElement quadraturaOreData={totaleOreStraordinarieRiposoSpostato} bold={false} />
                                                    <QuadratureElementTotali labelA={'TOTALE'} labelB={'(F)'} totaleOreQuadrature={totaleOreQuadratureF} />
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElementTotali labelA={'TOTALE GENERALE'} labelB={'(G)'} totaleOreQuadrature={totaleOreQuadratureG} />
                                                    <QuadratureElementTotali labelA={'DIFFERENZA'} labelB={'(D-G)'} totaleOreQuadrature={totaleOreQuadratureDMenoG} />
                                                    <QuadratureElementRapporti labelA={'RAPPORTO'} labelB={'(B/G)'} totaleOreQuadrature={totaleOreQuadratureRapportoBG} />
                                                    <QuadratureElementRapporti labelA={'RAPPORTO'} labelB={'(F/E)'} totaleOreQuadrature={totaleOreQuadratureRapportoFE} />
                                                    <QuadratureElementRapporti labelA={'RAPPORTO'} labelB={'(F/G)'} totaleOreQuadrature={totaleOreQuadratureRapportoFG} />
                                                    <QuadratureElementVuoto />
                                                    <QuadratureElement quadraturaOreData={totaleFlessibilita} bold={true} />
                                                    <QuadratureElementTotali labelA={'SOMMA ORE SOMMINISTRATI'} labelB={''} totaleOreQuadrature={totaleOreSomministrati} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="item_3 m_top_5">
                                            <div className="list_button penultimo_largo">
                                                <div id="w-node-c4b74f58-890f-de16-94ea-fe95f11de98d-867f153d" className="div_item_button">
                                                    <a id="w-node-c4b74f58-890f-de16-94ea-fe95f11de98e-867f153d" className={`button w-button`} onClick={(e) => csvData.length == 0 ? null : saveAsExcel(csvData, headers)}>Scarica Excel</a>
                                                </div>
                                                <div id="w-node-c4b74f58-890f-de16-94ea-fe95f11de98d-867f153d" className="div_item_button">
                                                    <a id="w-node-c4b74f58-890f-de16-94ea-fe95f11de98e-867f153d" className={`button w-button`} onClick={(e) => csvData.length == 0 ? null : print()}>Stampa PDF</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

QuadratureOre.propTypes = {
    getQuadraturaOreJob: PropTypes.func.isRequired,
    getStateQuadraturaJob: PropTypes.func.isRequired,
    cleanQuadrature: PropTypes.func.isRequired,
    getFestivita: PropTypes.func.isRequired,
    getFiliali: PropTypes.func.isRequired,
    richiesta: PropTypes.object.isRequired,
    filiale: PropTypes.object.isRequired,
    impostazione: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    richiesta: state.richiesta,
    auth: state.auth,
    impostazione: state.impostazione,
    filiale: state.filiale
});

export default connect(mapStateToProps, { getQuadraturaOreJob, getStateQuadraturaJob, cleanQuadrature, getFestivita, getFiliali })(QuadratureOre);
